var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[(_vm.label)?_c('div',{class:['form-label', { required: _vm.required }]},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('div',{staticClass:"l-inline l-gap-1 options",class:{ disabled: _vm.disabled }},_vm._l((_vm.colors),function(color){return _c('div',{key:color,staticClass:"color-swatch",class:{
                'color-swatch--selected': _vm.isColorSelected(color),
                disabled: _vm.disabled,
            },style:({
                background: color,
                borderColor: color,
            }),on:{"click":function($event){return _vm.selectColor(color)}}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }